import React from 'react';
import cn from 'classnames';
import Head from 'next/head';
import Contact from 'components/contact';
import Layout from 'components/layout';
import style from 'styles/activity/education.module.scss';
const IMG_PATH = 'https://devcdn.xylink.com/xylink_website_doc/images/activity/education/';
type ClassTitle = 'blue' | 'green';
/* 混合在线课堂*/
const mixList = [
  {
    title: '老师在教室上课',
    imgSrc: `${IMG_PATH}pc/class_01.png`,
    desc: '教师在配备互动教学终端的教室上课，还原真实上课场景，降低教师设备操作难度',
  },
  {
    title: '学生在家听课',
    imgSrc: `${IMG_PATH}pc/class_02.png`,
    desc: '学生使用电脑、平板或手机上课，通过小鱼客户端接收在教室老师的画面、课件以及板书，并参与双向互动交流',
  },
];
/* 在线互动课堂*/
const onlineList = [
  {
    title: '老师在家上课',
    imgSrc: `${IMG_PATH}pc/class_03.jpg`,
    desc: '老师在家，使用电脑授课和进行课堂管理。在音视频互动的同时，还可以共享教学课件、发送测试题目',
  },
  {
    title: '学生在家听课',
    imgSrc: `${IMG_PATH}pc/class_04.png`,
    desc: '学生使用电脑、平板或手机上课，通过小鱼客户端接收老师的画面、课件、签到提醒及随堂测试，并参与双向互动交流',
  },
];
/* 在线直播教学 */
const liveList = [
  {
    title: '老师教学直播',
    imgSrc: `${IMG_PATH}pc/class_05.png`,
    desc: '老师在教室用互动终端或在家用笔记本电脑，开启课程直播。直播采用创新技术，将多点互动和直播无缝结合',
  },
  {
    title: '学生观看直播',
    imgSrc: `${IMG_PATH}pc/class_06.png`,
    desc: '学生通过个人移动终端观看直播，并进行文字、点赞等互动交流。直播画面布局智能切换，教学重点最大化显示',
  },
];
const feature = [
  {
    title: '自动教师跟踪',
    iconSrc: `${IMG_PATH}pc/feature-icon_01.png`,
  },
  {
    title: '自动共享课件',
    iconSrc: `https://devcdn.xylink.com/xylink_website_doc/images/solution/group/pc/group_challenge_2.png`,
  },
  {
    title: '全自动录制',
    iconSrc: `https://devcdn.xylink.com/xylink_website_doc/images/solution/medical/pc/medical_challenge_2.png`,
  },
  {
    title: '录制画面智能布局',
    iconSrc: `${IMG_PATH}pc/feature-icon_02.png`,
  },
];

const system = [
  {
    src: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/education/pc/advantage_00.png',
    title: '多点接入，全面覆盖',
    desc: '支持超大规模并发呼叫，可\n实现数十万师生互动上课',
    mDesc: '支持超大规模并发呼叫，\n可实现数十万师生互动上课',
  },
  {
    src: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/education/pc/advantage_01.png',
    title: '简单易用，无需培训',
    desc: '软硬件终端操作便捷，普通用户\n即可使用，无需专业人员保障',
    mDesc: '软硬件终端操作便捷，普通用户\n即可使用，无需专业人员保障',
  },
  {
    src: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/education/pc/advantage_02.png',
    title: '网络适应强，高清无卡顿',
    desc: '提供高清流畅音视频体验，3G/\n4G网络仍可保障视频不卡不花',
    mDesc: '提供高清流畅音视频体验，3G/4G\n网络仍可保障视频不卡不花 ',
  },
  {
    src: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/education/pc/advantage_03.png',
    title: '开放接口，系统互联',
    desc: '开放SDK/API接口，与用户的其\n他系统、业务流程无缝融合',
    mDesc: '开放SDK/API接口，与用户的其他\n系统、业务流程无缝融合',
  },
];
const Education = () => {
  /*渲染不同课堂*/
  const renderClass = (prop: { title?: string; list: Record<string, string>[]; isBg?: boolean; titleBg?: ClassTitle }) => {
    const { title = '混合式互动课堂', list = [], isBg = false, titleBg = 'blue' } = prop;
    return (
      <div className={cn(style.classroom, isBg && style.bg)}>
        <p className={style.title}>{title}</p>
        <div className={style.content}>
          {list.map((item: any, index: number) => {
            return (
              <div key={item.title + index} className={style.case}>
                <div className={cn(style['case-title'], style[titleBg])}>{item.title}</div>
                <div className={style['case-info']}>
                  <img src={item.imgSrc} alt={item.title} />
                  <p>{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  return (
    <Layout layoutClass={style.layout} headerClass={style.header}>
      <Head>
        <title>三大互动课堂，助高校“云开学”</title>
      </Head>
      <div className={style.banner}>
        <img src={IMG_PATH + 'pc/banner-title.png'} alt="" className={cn(style.title, 'for-pc')} />
        <div className={cn(style.text, 'for-mobile')}>
          <p>三大互动课堂</p>
          <p>助高校 “云开学”</p>
        </div>
        <Contact isTry={false} className={style['contact']} />
      </div>
      <div className={style.characters}>
        <div className={style.content}>
          <img src="https://devcdn.xylink.com/xylink_website_doc/images/activity/onlineteaching/pc/quot-lasted.png" alt="" />
          <p>
            2021年2月10日，教育部印发提醒函，强调要综合考虑国内疫情形势变化，科学安排春季学期开学工作。小鱼易 <br className={'for-pc'} />
            连在线互动课堂方案，助力高校如期开学、延迟返校，快速灵活切换多样应用模式，构建远程互动教学“新常态”。
          </p>
        </div>
      </div>
      <div className={style.framework}>
        <p className={style.title}>方案架构</p>
        <img src={`${IMG_PATH}pc/scheme.png`} className={cn(style.img, 'for-pc')} alt="framework" />
        <img src={`${IMG_PATH}m/scheme.png`} className={cn(style.img, 'for-mobile')} alt="framework" />
      </div>
      {/* 混合在线课堂 */}
      {renderClass({ list: mixList, isBg: true })}
      <div className={style.feature}>
        <p className={style.title}>核心特色功能</p>
        <div className={style.content}>
          {feature.map((item: { title: string; iconSrc: string }) => {
            return (
              <div key={item.title} className={style['feature-item']}>
                <img src={item.iconSrc} alt="" />
                <p>{item.title}</p>
              </div>
            );
          })}
        </div>
      </div>
      {/* 在线互动课堂 */}
      {renderClass({ title: '在线互动课堂', list: onlineList, titleBg: 'green' })}
      {/* 在线直播教学 */}
      {renderClass({ title: '在线直播教学', list: liveList, isBg: true })}
      <div className={style.system}>
        <p className={style.title}>系统优势</p>
        <div className={style.content}>
          {system.map((item: any) => {
            return (
              <div key={item.title} className={style['scheme-item']}>
                <img src={item.src} alt={item.title} />
                <div className={style.text}>
                  <p className={style.title}>{item.title}</p>
                  <p className={cn(style.desc, 'for-pc')} dangerouslySetInnerHTML={{ __html: item.desc.replace(/\n/g, '<br/>') }}></p>
                  <p className={cn(style.desc, 'for-mobile')} dangerouslySetInnerHTML={{ __html: item.mDesc.replace(/\n/g, '<br/>') }}></p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={style.scheme}>
        <p className={style.title}>部分应用案例</p>
        <div className={style.content}>
          {new Array(12).fill(IMG_PATH).map((item: string, index: number) => (
            <img key={item + index} src={`${item}pc/case_${index + 1}.png`} alt=""></img>
          ))}
        </div>
      </div>
      <Contact className={style['footer-contact']} />
    </Layout>
  );
};

export default Education;
